export default "/images/438b211394fcd14482b7a3c222eda0f2.avif";